import { render, staticRenderFns } from "./Ordering.vue?vue&type=template&id=084e9292&"
import script from "./Ordering.vue?vue&type=script&lang=ts&"
export * from "./Ordering.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports